import * as React from 'react';
import './StatusHeader.scss';
import localeFormatingInstance from 'src/translation/localeFormating';
import { IStatusItem } from 'src/services/returns/typings';
import { ERmaStatus } from '../../StatusTab';

interface IStatusHeaderProps {
  status: IStatusItem;
  t?: any;
}

const StatusHeader: React.FC<IStatusHeaderProps> = ({ status, t }) => {
  const getIcon = (s: string): string => {
    if (s === ERmaStatus.NOT_SUBMITTED) {
      return 'rpds-remove-circle';
    } else if (s === ERmaStatus.IN_PROGRESS) {
      return 'rpds-clock';
    } else if (s === ERmaStatus.COMPLETED) {
      return 'rpds-check-circle';
    }else if (s === ERmaStatus.REJECTED_DAMAGE) {
      return 'rpds rpds-remove-circle';
    }else if (s === ERmaStatus.REJECTED_MISSING) {
      return 'rpds rpds-remove-circle';
    }else if (s === ERmaStatus.REJECTED_INSTALLED) {
      return 'rpds rpds-remove-circle';
    }else if (s === ERmaStatus.CANCELLED) {
      return 'rpds rpds-remove-circle';
    } else {
      return 'rpds-remove-circle';
    }
  };

  const getTranslatedStatus = (rawTxt: string) => {
    switch (rawTxt?.toLowerCase()) {
      case 'completed':
        return t('status.completed');
      case 'in progress':
        return t('status.inProgress');
      case 'not submitted':
        return t('status.notSubmitted');
      case 'rejected damage':
        return t('status.rejectedDamage');
      case 'rejected missing':
        return t('status.rejectedMissing');  
      case 'rejected installed':
        return t('status.rejectedInstalled');
      case 'cancelled':
        return t('status.cancelled');
      case 'partially_cancelled':
          return t('status.partiallyCancelled');      
      default:
        return rawTxt;
    }
  };

  return (
    <div className="rp-status-header">
      <div className="container-fluid">
        <div className="row">
          <div className="col-4 col-md-2">
            <p className="d-md-none rp-status-header-mobile">
              {t('myReturns.returnNo')}
            </p>
            <p>{status.rmaNumber}</p>
          </div>
          <div className="col-4 col-md-2">
            <p className="d-md-none rp-status-header-mobile">
              {t('myReturns.poNo')}
            </p>
            <p>{status.poNumber}</p>
          </div>
          <div className="col-4 col-md-2">
            <p className="d-md-none rp-status-header-mobile">
              {t('myOrders.status')}
            </p>
            <div className="rp-status-header-current-status">
              <i className={`${getIcon(status.status)}`} />
              <p className="rp-status-header-mobile-status">
                {/* {status.status.toLowerCase()} */}
                {getTranslatedStatus(status.status)}
              </p>
            </div>
          </div>
          <div className="col-2 d-none d-md-block">
            <p>
              {status.submissionDate &&
                localeFormatingInstance.formatDate(
                  status.submissionDate,
                  'short'
                )}
            </p>
          </div>
          <div className="col-2 d-none d-md-block">
            <p>
              {status.creditedDate &&
                localeFormatingInstance.formatDate(
                  status.creditedDate,
                  'short'
                )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusHeader;
